import { IC_CHAIN_ID, ICMethods } from '../constants';
export class WalletConnectPublicKey {
    constructor(derKey) {
        this.derKey = derKey;
    }
    static async getKey(client, topic) {
        const [derKey] = await client.request({
            topic,
            chainId: IC_CHAIN_ID,
            request: {
                method: ICMethods.getPubKey,
            },
        });
        if (!Array.isArray(derKey)) {
            throw new Error('Invalid "derKey" type. Response should be an array!');
        }
        return new WalletConnectPublicKey(new Uint8Array(derKey).buffer);
    }
    toDer() {
        return this.derKey;
    }
}
//# sourceMappingURL=WalletConnectPublicKey.js.map